import {
  PortalBgType,
  ThemeColorSchemas,
  PortalGradientColor,
  ThemeHexColorSchemas,
  PortalTextType,
  PortalSolidColor,
  tailwindPaletteHex,
  PortalHexTextColors,
  PortalBorderType,
  PortalShadowType,
} from '@nx-frontend/shared/types';
import {
  PortalHexBgColors,
  PortalHexBorderColors,
  PortalHexGradientColor,
  PortalHexShadowColors,
  PortalHexSolidColor,
} from '@nx-frontend/shared/types/portal-colors-hex';
import { getColorStyleClassName } from './getColorBgClassNames';

const BG_KEYS = Object.values(PortalBgType);
const TEXT_KEYS = Object.values(PortalTextType);
const BORDER_KEYS = Object.values(PortalBorderType);
const SHADOW_KEYS = Object.values(PortalShadowType);

export const themeColorsToHex = (themeColors: ThemeColorSchemas): ThemeHexColorSchemas => {
  return themeColors.reduce((acc, { schema, colors }) => {
    const bgHexColors = BG_KEYS.reduce((acc, key) => {
      acc[key] = portalGradientColorToHex(colors[key]);
      return acc;
    }, {} as PortalHexBgColors);

    const textHexColors = TEXT_KEYS.reduce((acc, key) => {
      acc[key] = portalSolidColorToHex(colors[key]);
      return acc;
    }, {} as PortalHexTextColors);

    const borderHexColors = BORDER_KEYS.reduce((acc, key) => {
      acc[key] = portalSolidColorToHex(colors[key]);
      return acc;
    }, {} as PortalHexBorderColors);

    const shadowHexColors = SHADOW_KEYS.reduce((acc, key) => {
      acc[key] = portalSolidColorToHex(colors[key]);
      return acc;
    }, {} as PortalHexShadowColors);

    acc.push({
      schema,
      colors: {
        key: colors.key,
        ...bgHexColors,
        ...textHexColors,
        ...borderHexColors,
        ...shadowHexColors,
      },
    });

    return acc;
  }, [] as ThemeHexColorSchemas);
};

export const portalSolidColorToHex = (color: PortalSolidColor): PortalHexSolidColor => {
  return [tailwindPaletteHex[color[0]]];
};

export const portalGradientColorToHex = (color: PortalGradientColor): PortalHexGradientColor => {
  const result: PortalHexGradientColor = [tailwindPaletteHex[color[0]]];
  const className = getColorStyleClassName(color);
  if (typeof color[1] === 'string') {
    result.push(tailwindPaletteHex[color[1]]);
  }
  result.push(className);
  return result;
};
